import { render, staticRenderFns } from "./ComponentDailyWinner.vue?vue&type=template&id=bc470aac"
import script from "./ComponentDailyWinner.vue?vue&type=script&lang=js"
export * from "./ComponentDailyWinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports